var CenterOfMass = (function () {
    function CenterOfMass() {
        this.delta = 0.01;
        this.heightOffset = 0.1;
    }
    CenterOfMass.prototype.getDelta = function () {
        return this.delta;
    };
    CenterOfMass.prototype.getHeightOffset = function () {
        return this.heightOffset;
    };
    return CenterOfMass;
}());
var AnatomicalAnalytics = (function () {
    function AnatomicalAnalytics() {
        this.groundReactionForce = {};
        this.centerOfMass = new CenterOfMass();
        this.knee = {};
        this.features = ['groundReactionForce', 'centerOfMass', 'centerOfMassUpperBody', 'knee', 'hip', 'sacral'];
        this.enabledFeatures = [];
    }
    AnatomicalAnalytics.prototype.enabled = function (feature) {
        return undefined !== this.enabledFeatures.find(function (el) { return el === feature; });
    };
    AnatomicalAnalytics.prototype._enable = function (feature, en) {
        if (undefined !== this.features.find(function (el) { return el === feature; })) {
            if (en) {
                if (undefined === this.enabledFeatures.find(function (el) { return el === feature; })) {
                    this.enabledFeatures.push(feature);
                }
            }
            else {
                this.enabledFeatures = this.enabledFeatures.reduce(function (acc, el) {
                    if (el !== feature) {
                        acc.push(el);
                    }
                    return acc;
                }, []);
            }
        }
    };
    AnatomicalAnalytics.prototype.enable = function (feature, en) {
        var _this = this;
        if (en === void 0) { en = true; }
        if (Array.isArray(feature)) {
            feature.forEach(function (f) { return _this._enable(f, en); });
        }
        else {
            this._enable(feature, en);
        }
    };
    return AnatomicalAnalytics;
}());
export { AnatomicalAnalytics };
//# sourceMappingURL=anatomical-analytics.js.map